import React, { useState } from "react";
import {
  Page,
  Document,
  StyleSheet,
  Image,
  View,
  Text,
} from "@react-pdf/renderer";
import InvoiceTitle from "./Heading";
import InvoiceNo from "./InvoiceNo";
import BillTo from "./BillTo";
import ShippingItemsTable from "./Shipping-Table";
import InvoiceItemsTable from "./Items-Table";
import NotesForKO from "./NotesForKO";
import InvoiceThankYouMsg from "./Thank-You";

const styles = StyleSheet.create({
  page: {
    backgroundColor: "#fff",
    fontFamily: "Helvetica",
    fontSize: 11,
    paddingTop: 30,
    paddingLeft: 50,
    paddingRight: 50,
    paddingBottom: 40,
    lineHeight: 1.5,
    flexDirection: "column",
  },
  watermarkContainer: {
    position: "absolute",
    top: "40%",
    left: "35%",
    width: "100%",
    height: "100%",
    transform: "translate(-50%, -50%) rotate(-30deg)",
    opacity: 0.3,
  },
  watermark: {
    fontSize: 100,
    color: "gray",
    fontFamily: "Times-Roman",
    fontWeight: "bold",
    fontStyle: "italic",
  },
  footer: {
    position: "absolute",
    bottom: 20,
    left: 0,
    right: 0,
    textAlign: "center",
    fontSize: 8,
    color: "gray",
  },
  label: {
    marginTop: 24,
    flexDirection: "column",
  },
  titleContainer: {
    marginTop: 20,
  },
  reportTitle: {
    color: "black",
    fontSize: 10,
    textAlign: "center",
    textTransform: "uppercase",
    fontWeight: "extrabold",
  },
  Quote_Title: {
    color: "black",
    fontSize: 14,
    textAlign: "center",
    textTransform: "uppercase",
    fontWeight: "bold",
  },
  logo: {
    width: 150,
    height: 50,
    marginLeft: "auto",
    marginRight: "auto",
    alignContent: "center",
  },
  Hub1: {
    width: 130,
    height: 42,
  },
  Hub3: {
    width: 87,
    height: 59,
  },
  Hub2: {
    width: 65,
    height: 25,
  },
  NonGSAHub1: {
    width: 91,
    height: 32,
  },
  Image_con: {
    flexDirection: "row",
    backgroundColor: "#fff",
  },
  Address: {
    width: 190,
    height: 40,
  },
});

const Watermark = () => (
  <View style={styles.watermarkContainer}>
    <Text style={styles.watermark}>Aspetto Inc</Text>
  </View>
);

const Footer = () => (
  <View style={styles.footer}>
    <Text>ISO certified ISO 9001:2015</Text>
    <Text>Inc. 5000 America's Fastest Growing Private Companies</Text>
  </View>
);
const PdfDocument = ({ invoicedata }) => {
  console.log("invoicedata", invoicedata);

  const [pageNumber, setPageNumber] = useState(1);
  const [numberOfPages, setNumberOfPages] = useState(null);

  console.log("invoicedata", invoicedata);

  return (
    <Document>
      <Page size="A4" style={styles.page} orientation="landscape" wrap>
        <InvoiceTitle invoice={invoicedata} />
        <InvoiceNo invoice={invoicedata} />
        <BillTo invoice={invoicedata} />
        <ShippingItemsTable invoice={invoicedata} />
        <InvoiceItemsTable invoice={invoicedata} />
        {/* <NotesForKO invoice={invoicedata}/>  */}
        <Footer />
        <InvoiceThankYouMsg />
      </Page>
    </Document>
  );
};

export default PdfDocument;
